export default {
	'first_name:required': 'Keresztnév megadása kötelező!',
	'last_name:required': 'Vezetéknév megadása kötelező!',
	'name:required': 'Név megadása kötelező!',
	'message:required': 'Üzenet megadása kötelező!',
	'email:invalid': 'Érvénytelen email cím!',
	'email:required': 'Email cím megadása kötelező!',
	'postal_code:invalid': 'Hibás irányítószám!',
	'postal_code:required': 'Irányítószám megadása kötelező!',
	'city:required': 'Település megadása kötelező',
	'address:required': 'Lakcím megadása kötelező!',
	'street_address:required': 'Cím megadása kötelező!',
	'date_of_birth:required': 'Születési dátum megadása kötelező!',
	'accept_terms:required': 'Kérjük, fogadja el az adatkezelési tájékoztatót!',
	'date_of_birth:too_late': 'Családi kártya csak 18 év felett igényelhető!',
	'phone_number:required': 'Telefonszám megadása kötelező!',
	'subject:required': 'A tárgy megadása kötelező',
	'biography_hu:required': 'Magyar nyelvű bemutatkozó szöveg megadása kötelező',
	'biography_en:required': 'Angol nyelvű bemutatkozó szöveg megadása kötelező',
	'contract_type:required': 'Művészeti tevékenység megadása kötelező',
	'finished:invalid': 'Diploma megszerzésének éve nem érvényes!',
	'image_profile:invalid': 'A profilkép formátuma nem megfelelő!',
	'image_profile:required': 'Profilkép megadása kötelező',
	'url_portfolio:invalid': 'Érvénytelen portfóliu URL!',
	'finished:required': 'Diploma megszerzésének éve kötelező!',
};
